import PropTypes from "prop-types";
// form
import { FormProvider as Form } from "react-hook-form";

// ----------------------------------------------------------------------

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  clasess: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default function FormProvider({ children, onSubmit, methods, classes, ...other }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} className={classes} {...other}>
        {children}
      </form>
    </Form>
  );
}
